/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Crop_FullInputs */

const en_ocr_crop_full = /** @type {(inputs: Ocr_Crop_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full Frame`)
};

const fr_ocr_crop_full = /** @type {(inputs: Ocr_Crop_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plein cadre`)
};

const de_ocr_crop_full = /** @type {(inputs: Ocr_Crop_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollbild`)
};

const it_ocr_crop_full = /** @type {(inputs: Ocr_Crop_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full Frame`)
};

const ru_ocr_crop_full = /** @type {(inputs: Ocr_Crop_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полнокадровый`)
};

const es_ocr_crop_full = /** @type {(inputs: Ocr_Crop_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuadro completo`)
};

const zh_cn2_ocr_crop_full = /** @type {(inputs: Ocr_Crop_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全画幅`)
};

const ja_ocr_crop_full = /** @type {(inputs: Ocr_Crop_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フルフレーム`)
};

const hi_ocr_crop_full = /** @type {(inputs: Ocr_Crop_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्ण फ्रेम`)
};

const pt_pt2_ocr_crop_full = /** @type {(inputs: Ocr_Crop_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quadro completo`)
};

/**
* | output |
* | --- |
* | "Full Frame" |
*
* @param {Ocr_Crop_FullInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_crop_full = /** @type {((inputs?: Ocr_Crop_FullInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Crop_FullInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_crop_full(inputs)
	if (locale === "de") return de_ocr_crop_full(inputs)
	if (locale === "it") return it_ocr_crop_full(inputs)
	if (locale === "ru") return ru_ocr_crop_full(inputs)
	if (locale === "es") return es_ocr_crop_full(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_crop_full(inputs)
	if (locale === "ja") return ja_ocr_crop_full(inputs)
	if (locale === "hi") return hi_ocr_crop_full(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_crop_full(inputs)
	return en_ocr_crop_full(inputs)
});